<ng-container *ngIf="formChanged$ | async"></ng-container>

<form *ngIf="data$ | async" [formGroup]="form" novalidate cslEnterLikeTab class="flex flex-row space-x-2">
  <mat-form-field class="mini-input flex-auto">
    <mat-label i18n>Длина (мм)</mat-label>
    <input cslSelectInputsByClick matInput type="number" formControlName="length" />
    <mat-error *ngIf="form.get('length').hasError('required')" i18n>Заполните поле</mat-error>
  </mat-form-field>

  <mat-form-field class="mini-input flex-auto">
    <mat-label i18n>Ширина (мм)</mat-label>
    <input cslSelectInputsByClick matInput type="number" formControlName="width" />
    <mat-error *ngIf="form.get('width').hasError('required')" i18n>Заполните поле</mat-error>
  </mat-form-field>
</form>

<div class="text-sm red-fg mb-4" *ngIf="form.hasError('size') && form.dirty">
  <div *ngIf="form.hasError('size')">{{ form.getError('size') }}</div>
  <!-- <div i18n
    >Минимальный габаритный размер: {{ form.getError('panelSize').overallSize.length.min }}×{{
      form.getError('panelSize').overallSize.width.min
    }}</div
  >
  <div i18n
    >Максимальный габаритный размер: {{ form.getError('panelSize').overallSize.length.max }}×{{
      form.getError('panelSize').overallSize.width.max
    }}</div
  > -->
</div>
